module fdm.performedLegs {

    angular.module('fdm.performedLegs')
        .config(($stateProvider: ng.ui.IStateProvider, $locationProvider: ng.ILocationProvider) => {
            dg.uiRouter.StateProviderBuilderService.configure($stateProvider)
                .listState('performedLegs', 'performed-legs',
                    'performed-leg/list', {
                    options: () => <dg.actions.IQueryInvokerOptions>{
                        compositeDisplayers: <dg.actions.ICompositeDisplayerOptions>[
                            <dg.lists.IGridListOptions>dg.lists.ListOptionsService.getGridOptions({
                                uiGrid: {
                                    columnDefs: [
                                        { field: 'aggregate', width: 110, displayName: 'No' },
                                        { field: 'matchedLeg', minWidth: 80 },
                                        { field: 'aircraft', width: 70 },
                                        { field: 'departureDate', minWidth: 80 },
                                        { field: 'departure', minWidth: 70 },
                                        { field: 'arrival', minWidth: 70 },
                                        { field: 'arrivalDate', minWidth: 80 },
                                        { field: 'duration', minWidth: 72 },
                                        { field: 'creeatedOn', minWidth: 80 }
                                    ]
                                }
                            })
                        ]
                    }
                })
                .commandState('syncPerformedLegsCommand', {
                    apiUrl: 'performed-leg/sync-performed-legs',
                    propTemplateUrl: '/app/src/performed-legs/sync-performed-legs-prop-template.html',
                    modalOptions: {
                        windowClass: ''
                    }
                });
        });
}
